import {Mercancia} from "../../entities/solicitudes/Mercancia";

export const SAVE_MERCANCIAS = "SAVE_MERCANCIAS";

interface ISaveMercancias {
    type: typeof SAVE_MERCANCIAS
    mercancias: Mercancia[]
}

export type MercanciaActionTypes = ISaveMercancias
